/* eslint-disable no-restricted-syntax */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Select } from '@stockx/ui';
import { Money } from '@app/currency';
import type { LegacyChildProduct } from '@app/types';
import { SizeSelectProps } from './SizeSelectProps';

const SizeSelectNew: React.FC<SizeSelectProps> = ({
  product,
  setValue,
  interstitialKey,
  selectedSizes,
  inputNumber,
}) => {
  const { t } = useTranslation();

  const sizeSelectOptions = useMemo(() => {
    const ops = [{ value: '', text: t('Select') }];

    if (product) {
      const products: LegacyChildProduct[] = [];

      for (const id in product.children) {
        products.push(product.children[id]);
      }

      let modifySelectedSizes;

      if (selectedSizes && selectedSizes.length) {
        const copySelectedSizes = [...selectedSizes];

        // @ts-expect-error ts-migrate(2538) FIXME: Type 'undefined' cannot be used as an index type.
        if (copySelectedSizes[inputNumber]) {
          // @ts-expect-error ts-migrate(2538) FIXME: Type 'undefined' cannot be used as an index type.
          copySelectedSizes[inputNumber] = '';
        }

        modifySelectedSizes = copySelectedSizes;
      }

      products
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        .sort((productA, productB) => +productA.shoeSize - +productB.shoeSize)
        .forEach((child) => {
          if (
            !modifySelectedSizes ||
            (modifySelectedSizes && !modifySelectedSizes.includes(child.id))
          ) {
            const lowestAsk =
              child.market && child.market.lowestAsk > 0
                ? Money.getDollars(child.market.lowestAsk)
                : '--';

            ops.push({
              value: child.id,
              text: `${child.sizeTitle} ${child.shoeSize} (${lowestAsk})`,
            });
          }
        });
    }

    return ops;
  }, [product, selectedSizes, interstitialKey]); // eslint-disable-line react-hooks/exhaustive-deps

  if (product.children && Object.keys(product.children).length <= 1) {
    return null;
  }

  return (
    <Select
      data-testid="size-select-list"
      onChange={(e) => setValue(e.target.value)}
    >
      {sizeSelectOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.text}
        </option>
      ))}
    </Select>
  );
};

export default SizeSelectNew;
